import * as breakpoints from "../constants/breakpoints";

export function isMobileOnly() {
    return window.innerWidth < breakpoints.tabletWidth;
}

export function isTabletAndDown() {
    return window.innerWidth < breakpoints.desktopWidth;
}
